import { Signal, InjectionToken } from '@angular/core';
import { BaseSplitButtonComponent } from './base-split-button.component';

export interface SplitButtonsRegistration<T> {
  buttonList: Signal<ReadonlyArray<BaseSplitButtonComponent<T>>>;
  registerButton(button: BaseSplitButtonComponent<T>): void;
  unregisterButton(button: BaseSplitButtonComponent<T>): void;
}

export const SplitButtonsRegistration = new InjectionToken<SplitButtonsRegistration<unknown>>('SplitButtonsRegistration');
